import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const [menuActive, setMenuActive] = useState(false);
  const [overviewDropdown, setOverviewDropdown] = useState(false);
  const [productsDropdown, setProductsDropdown] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("user");
    navigate("/login");
  };

  const handleSmoothScroll = (sectionId) => {
    setMenuActive(false);
    // Check if we're not on the home page, navigate there first
    if (window.location.pathname !== '/') {
      navigate('/');
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);
    } else {
      // Already on home page, scroll directly
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };

  // Close menu on window resize (same as before)
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && menuActive) setMenuActive(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [menuActive]);

  return (
    <header>
      <nav className="navbar">
        <div className="container">
          {/* Logo / Title */}
          <div
            className="logo"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/")}
          >
            <img
              src="https://cdn.ivaluetv.com/public/Ivalue transparent.png"
              alt="iValue"
              className="logo-img"
            />
          </div>

          {/* Navigation Links */}
          <div className={`nav-links ${menuActive ? "active" : ""}`}>
            {/* Dropdown 1: Overview */}
            <div 
              className="nav-dropdown"
              onMouseEnter={() => setOverviewDropdown(true)}
              onMouseLeave={() => setOverviewDropdown(false)}
            >
              <button className="dropdown-toggle">
                Overview
                <svg width="12" height="8" viewBox="0 0 12 8" fill="currentColor" style={{ marginLeft: '6px', transition: 'transform 0.3s ease', transform: overviewDropdown ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                  <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <div className={`dropdown-menu ${overviewDropdown ? 'active' : ''}`}>
                <Link to="/" onClick={() => { setMenuActive(false); setOverviewDropdown(false); }}>
                  Home
                </Link>
                <a href="#solutions" onClick={(e) => { e.preventDefault(); handleSmoothScroll('solutions'); setOverviewDropdown(false); }}>
                  Solutions
                </a>
                <a href="#usecases" onClick={(e) => { e.preventDefault(); handleSmoothScroll('usecases'); setOverviewDropdown(false); }}>
                  Use Cases
                </a>
                <a href="#industries" onClick={(e) => { e.preventDefault(); handleSmoothScroll('industries'); setOverviewDropdown(false); }}>
                  Industries
                </a>
              </div>
            </div>

            {/* Dropdown 2: Products */}
            <div 
              className="nav-dropdown"
              onMouseEnter={() => setProductsDropdown(true)}
              onMouseLeave={() => setProductsDropdown(false)}
            >
              <button className="dropdown-toggle">
                Benefits
                <svg width="12" height="8" viewBox="0 0 12 8" fill="currentColor" style={{ marginLeft: '6px', transition: 'transform 0.3s ease', transform: productsDropdown ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                  <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <div className={`dropdown-menu ${productsDropdown ? 'active' : ''}`}>
                <Link to="/ingestionFiltering" onClick={() => { setMenuActive(false); setProductsDropdown(false); }}>
                  Ingestion Filtering
                </Link>                
                <Link to="/fieldDetection" onClick={() => { setMenuActive(false); setProductsDropdown(false); }}>
                  Field Detection
                </Link>
                <Link to="/siemReference" onClick={() => { setMenuActive(false); setProductsDropdown(false); }}>
                  Streaming Fabric
                </Link>
              </div>
            </div>

            {/* Regular Links */}
            <Link to="/architecture" onClick={() => setMenuActive(false)}>
              Architecture
            </Link>
            <Link to="/contact" onClick={() => setMenuActive(false)}>
              Contact Us
            </Link>

            {/* 🔒 Auth section (kept exactly as your logic) */}
            {user && (
              <Link to="/dashboard" onClick={() => setMenuActive(false)}>
                My Dashboard
              </Link>
            )}
            {!user ? (
              <Link to="/login" className='login' onClick={() => setMenuActive(false)}>
                Login
              </Link>
            ) : (
              <button
                className="login"
                onClick={() => {
                  setMenuActive(false);
                  handleLogout();
                }}
              >
                Logout
              </button>
            )}
          </div>

          {/* Mobile Menu Button */}
          <div
            className={`mobile-menu-btn ${menuActive ? "active" : ""}`}
            onClick={() => setMenuActive(!menuActive)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
